export default __webpack_public_path__ + "static/media/StaticPage5.b3fc34b3.txt";